import { useTranslation } from 'next-i18next';
import * as React from 'react';
import { ReactElement } from 'react';
import { RiAlarmWarningFill } from 'react-icons/ri';

export default function NotFoundPage(): ReactElement {
  const { t } = useTranslation('common');
  return (
    <section className='bg-white'>
      <div className='layout flex min-h-screen flex-col items-center justify-center text-center text-black'>
        <RiAlarmWarningFill
          size={60}
          className='drop-shadow-glow text-red-500 animate-flicker'
        />
        <h1 className='text-4xl md:text-6xl mt-24'>{t('404')}</h1>
      </div>
    </section>
  );
}
